import {
  Alert,
  BackgroundColor,
  Button,
  Card,
  Color,
  Header,
  LinkButton,
  Paragraph
} from '@eggplant/pattern-library'
import {
  SPACES_LANDING_IMAGE,
  SPACES_LANDING_IMAGE_DARK
} from '@eggplant/routing'
import { LinkToReleaseDocumentation } from '@eggplant/embedded-documentation'
import { type CSSProperties } from 'react'
import { ThemeConsumer } from '@eggplant/context'

interface Props {
  onClose: () => void
}

const containerWrapperStyle: CSSProperties = {
  maxWidth: '500px',
  maxHeight: '500px'
}

const backgroundWrapperStyle: CSSProperties = {
  position: 'relative',
  borderRadius: '6px 6px 0 0',
  height: '276px'
}

const alertWrapperStyle: CSSProperties = {
  position: 'absolute',
  top: '10px',
  right: '24px'
}

const imageStyle: CSSProperties = {
  position: 'absolute',
  top: '20px',
  left: '25px',
  height: '100%',
  width: '90%'
}

const contentWrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '24px',
  padding: '24px',
}

const innerContentWrapperStyle: CSSProperties = {
  paddingTop: '8px'
}

const buttonsWrapperStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between'
}

const SpaceAnnouncementPopOut = ({
  onClose
}: Props) =>
  <ThemeConsumer>
    {
      ({ theme }) =>
        <div style={containerWrapperStyle}>
          <Card>
            <div style={backgroundWrapperStyle}>
              <BackgroundColor variant='ThemeInformationBackground'>
                <div>
                  <img
                    alt='spaces landing page'
                    src={
                      theme === 'eggplantDark'
                        ? SPACES_LANDING_IMAGE_DARK
                        : SPACES_LANDING_IMAGE
                    }
                    style={imageStyle}
                  />
                </div>
              </BackgroundColor>
              <div style={alertWrapperStyle}>
                <Alert variant='information'>
                  <strong>
                    New feature
                  </strong>
                </Alert>
              </div>
            </div>
            <div style={contentWrapperStyle}>
              <div>
                <Header
                  hasNoTopMargin
                  lessWeight
                  rank={3}
                >
                  Spaces are here!
                </Header>
                <div style={innerContentWrapperStyle}>
                  <Paragraph>
                    <Color variant='theme-description-text'>
                      Spaces help you organise work by project or team.
                      <br />
                      If you already have assets, they are available in the Shared space, so you can continue working as before.
                      You can also create new spaces to more easily organize and control access to your future work.
                    </Color>
                  </Paragraph>
                </div>
              </div>
              <div style={buttonsWrapperStyle}>
                <Button
                  onClick={onClose}
                  title='close'
                  variant='secondary'
                >
                  Close
                </Button>
                <LinkButton
                  onClick={onClose}
                  variant='primary'
                >
                  <LinkToReleaseDocumentation />
                </LinkButton>
              </div>
            </div>
          </Card>
        </div>
    }
  </ThemeConsumer>

export default SpaceAnnouncementPopOut